import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment } from "react";
import { useUiTranslator } from "@plansoft-configuration-renderer/localization";
export function NumericRangeStepWidth(props) {
    const t = useUiTranslator();
    const { valueStepWidth, unitSymbol, numberFormat } = props;
    if (valueStepWidth == null) {
        return _jsx(Fragment, {});
    }
    const stepWidth = numberFormat.format(valueStepWidth);
    const stepWidthText = t("ConfigurationRenderer:NumericRange.stepWidth", "± {{stepWidth}} {{unitSymbol}}", { stepWidth, unitSymbol });
    return _jsx(Fragment, { children: stepWidthText });
}
//# sourceMappingURL=NumericRangeStepWidth.js.map